module.exports = __webpack_public_path__ + "img/20241115-081133.2926f72c.png";